import React from "react";
import { _RCSDashboard } from "../../features/overview";
const RCSDashboard = () => {
  return (
    <div>
      <h2>RCS Dashboard</h2>
      <_RCSDashboard />
    </div>
  );
};

export default RCSDashboard;
